<template>
  <div class="menu-full">
    <v-app-bar
      app
      color="primary"
      dense
      :class="[{ '' /**desktop-mode-padding */: $vuetify.breakpoint.mdAndUp }, 'header', 'primaryText--text']"
    >
      <v-row>
        <v-col cols="2" class="d-flex">
          <v-app-bar-nav-icon v-if="showNavBack" @click="navBack">
            <v-icon>mdi-arrow-left</v-icon>
          </v-app-bar-nav-icon>

          <!-- <v-app-bar-nav-icon v-if="!$vuetify.breakpoint.mdAndUp" @click="onClickMenu"></v-app-bar-nav-icon> -->
        </v-col>

        <v-col cols="8" class="d-flex justify-center">
          <div>
            <v-toolbar-title
              class="header-title1"
              v-if="$store.state.store != null && $store.state.store.info != null"
              >{{ $store.getters.storeName }}</v-toolbar-title
            >
            <v-toolbar-title class="header-title2">
              <div v-if="mode == 'search'">
                {{ $t("search") }}
              </div>
              <div v-else>
                {{ $t($store.getters.orderFrom)
                }}<span v-if="catDescr !== undefined && catDescr != ''" class="header-title2-feature">{{
                  catDescr
                }}</span>
              </div>
            </v-toolbar-title>
          </div>
        </v-col>

        <v-col cols="2" align-self="end" style="text-align: right">
          <v-badge
            v-show="showCart"
            :value="$store.state.order.qtyTotal"
            :content="$store.state.order.qtyTotal"
            color="accent"
            class="accentText--text"
            overlap
            offset-x="20"
            offset-y="20"
          >
            <v-app-bar-nav-icon @click="checkOutClicked">
              <v-icon>mdi-cart-outline</v-icon>
            </v-app-bar-nav-icon>
          </v-badge>
        </v-col>
      </v-row>
    </v-app-bar>

    <v-container v-if="$store.state.store != null" class="mt-n3 x-no-max-width">
      <div v-if="mode == 'search'" class="search-box d-flex">
        <v-text-field
          clearable
          v-model="searchText"
          :label="$t('search')"
          @input="searchItem"
          @click:clear="searchItem"
        ></v-text-field>
      </div>

      <v-row class="menu-row">
        <v-col class="menu-col" cols="12" sm="6" md="6" lg="4" x-xl="3" v-for="item in items" :key="item.ID">
          <MenuItemEle :item="item" @itemClicked="itemClicked"></MenuItemEle>
        </v-col>
      </v-row>
    </v-container>

    <LoginSelector
      ref="loginSelector"
      :show="showLoginSelector"
      @cancel="loginCancel()"
      @completed="loginCompleted()"
    ></LoginSelector>

    <v-overlay :value="refreshing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import LoginSelector from "@/components/LoginSelector.vue";
import MenuItemEle from "@/components/MenuItemEle.vue";

export default {
  beforeRouteLeave(to, from, next) {
    if (to.name == "StoreHome" && this.$store.state.order.orderItems.length > 0) {
      this.$root.confirmDialog(this.$t("confirm_leave_title", "", this.$t("confirm_leave_question"))).then(resp => {
        next(resp);
      });
    } else next();
  },

  components: {
    LoginSelector,
    MenuItemEle,
  },

  data() {
    return {
      refreshing: false,

      prevCompanyCode: "",

      mode: "",
      searchText: "",

      searchMenuText: "",
      searchMenuResult: [],

      searchRedeemText: "",
      searchRedeemResult: [],

      showNavBack: false,
      showCart: false,
      showLoginSelector: false,

      catIDs: [],
      catCodes: [],
      itemIDs: [],
      itemCodes: [],

      //items: [],

      sideOrder: false,
      getNewBundleItem: null,
    };
  },

  activated() {
    console.log("menu-item activated", this.$route.params);

    if (this.$store.getters.storeCompanyCode != this.prevCompanyCode) {
      this.mode = "menu";

      this.searchText = "";

      this.searchMenuText = "";
      this.searchRedeemResult = [];

      this.searchRedeemText = "";
      this.searchMenuResult = [];

      this.prevCompanyCode = this.$store.getters.storeCompanyCode;
    }

    if (this.$route.params.sideOrder != null) this.sideOrder = this.$route.params.sideOrder;
    this.getNewBundleItem = null;
    if (
      (this.$route.params.catIDs != null ||
        this.$route.params.catCodes != null ||
        this.$route.params.itemIDs != null ||
        this.$route.params.itemCodes != null) &&
      (this.$store.state.routeFrom.name == "MenuFull" ||
        this.$store.state.routeFrom.name == "MenuCategory" ||
        this.$store.state.routeFrom.name == "OrderBundle")
    ) {
      this.mode = "menu";

      this.refreshing = true;
      this.showNavBack = true;

      if (this.$route.params.catIDs != null && Array.isArray(this.$route.params.catIDs))
        this.catIDs = this.$route.params.catIDs;
      else this.catIDs = null;

      if (this.$route.params.catCodes != null && Array.isArray(this.$route.params.catCodes))
        this.catCodes = this.$route.params.catCodes;
      else this.catCodes = null;

      if (this.$route.params.itemIDs != null && Array.isArray(this.$route.params.itemIDs))
        this.itemIDs = this.$route.params.itemIDs;
      else this.itemIDs = null;

      if (this.$route.params.itemCodes != null && Array.isArray(this.$route.params.itemCodes))
        this.itemCodes = this.$route.params.itemCodes;
      else this.itemCodes = null;

      if (this.$route.params.getNewBundleItem != null) {
        this.getNewBundleItem = this.$route.params.getNewBundleItem;
      }

      this.rest_canAcceptOrder(this.$store.state.order.orderType)
        .then(resp => {
          this.$store.state.storeOrderHours = resp;
        })
        .finally(() => {
          this.refreshing = false;
        });
    } else if (this.$route.params.mode == "search") {
      this.mode = this.$route.params.mode;
      this.showNavBack = true;
      this.showCart = true;

      if (this.$store.state.orderMenu == 1) {
        this.searchText = this.searchRedeemText;
      } else {
        this.searchText = this.searchMenuText;
      }
    }
    this.showCart = this.$route.params.getNewBundleItem == null;
  },

  computed: {
    catDescr() {
      let descr = "";

      if (
        this.catIDs != null &&
        this.catIDs.length == 1 &&
        this.catCodes == null &&
        this.itemIDs == null &&
        this.itemCodes == null
      ) {
        if (this.catIDs[0] == -1) {
          descr = this.$t("chef_recommendation");
        } else if (this.catIDs[0] == -2) {
          descr = this.$t("redeemable_category");
        } else {
          let catID = this.catIDs[0];
          let cat = this.menu.find(c => c.ID == catID);
          if (cat != null) {
            if (this.$store.state.descrIndex == 1) {
              if (cat.descr1 != "") {
                descr = cat.descr1;
              }
            } else if (this.$store.state.descrIndex == 2) {
              if (cat.descr2 != "") {
                descr = cat.descr2;
              }
            } else {
              if (cat.descr != "") {
                descr = cat.descr;
              }
            }
          } else {
            descr = this.$t("category");
          }
        }
      } else {
        descr = this.$t("category");
      }

      return descr;
    },

    menu() {
      let n_menu = [];
      if (this.$store.state.orderMenu == 1) {
        n_menu = this.$store.state.redeemMenu;
      } else {
        n_menu = this.$store.state.menu;
      }

      if (n_menu == null) {
        return [];
      } else {
        n_menu = n_menu.filter(cat => cat.ID < 0 || cat.menuTypes.includes(this.$store.state.order.orderType));
      }

      return n_menu;
    },

    items() {
      let n_items = [];

      let all_items = [];
      if (this.$store.state.orderMenu == 1) all_items = this.$store.state.redeemItems;
      else all_items = this.$store.state.items;

      if (this.mode == "menu") {
        if (this.catIDs != null) {
          if (this.catIDs.length == 1 && (this.catIDs[0] == -1 || this.catIDs[0] == -2)) {
            let cat = this.menu.find(c => c.ID == this.catIDs[0]);
            if (cat != null) {
              n_items = n_items.concat(cat.items.filter(item => this.isItemShowing(item)));
            }
          } else
            n_items = n_items.concat(
              all_items.filter(item => this.isItemShowing(item) && this.catIDs.includes(item.catID))
            );
        }
        if (this.catCodes != null) {
          n_items = n_items.concat(
            all_items.filter(
              item => this.isItemShowing(item) && item.catBarcode != "" && this.catCodes.includes(item.catBarcode)
            )
          );
        }
        if (this.itemIDs != null) {
          n_items = n_items.concat(
            all_items.filter(item => this.isItemShowing(item) && this.itemIDs.includes(item.ID))
          );
        }
        if (this.itemCodes != null) {
          n_items = n_items.concat(
            all_items.filter(
              item => this.isItemShowing(item) && item.barcode != "" && this.itemCodes.includes(item.barcode)
            )
          );
        }
      } else if (this.mode == "search") {
        if (this.$store.state.orderMenu == 1) n_items = this.searchRedeemResult;
        else n_items = this.searchMenuResult;
      }

      if (n_items == null) n_items = [];

      return n_items;
    },
  },

  methods: {
    onClickMenu() {
      this.$store.state.appBar.showDrawer = true;
    },

    isItemShowing(item) {
      let b1 = item.descr.substring(0, 1) != "?" && item.descr.substring(0, 1) != "*";
      if (this.getNewBundleItem == null) return b1 && !item.bItem;
      else return b1 && (item.bItems == null || item.bItems.length == 0);
    },

    async itemClicked(item) {
      console.log(item);
      if (!this.$store.getters.storeMenuMode) {
        if (item.orderDisabled || item.disabled) return;

        if (this.$store.getters.itemStockEnabled) {
          let response = await this.rest_getItemSoldout([item.ID]);
          if (response.result == "ok" && response.items.length == 1) {
            if (item.soldout) {
              if (!response.items[0].soldout) {
                item.soldout = false;
                this.$root.messageDialog(this.$store.getters.itemDescr(item), "", this.$t("MENU.in_stock"));
              }
            } else {
              if (response.items[0].soldout) {
                item.soldout = true;
                this.$root.messageDialog(this.$store.getters.itemDescr(item), "", this.$t("MENU.out_of_stock"));
              }
            }
          }
        }

        if (item.soldout) return;
      }

      if (this.getNewBundleItem != null) {
        this.getNewBundleItem(item).then(() => {
          this.navBack();
        });
      } else {
        let canNav = true;
        if (item.redeemItem && this.$store.state.member == null) {
          canNav = await this.$root.memberLoginDialog();
        }

        if (canNav) {
          if (this.$store.state.itemFastAdd && item.bItems.length == 0 && item.options.length == 0) {
            if (!this.$store.getters.acceptOrder) {
              this.$root.messageDialog(this.$t("not_acception_order"), "", this.$t("not_acception_order_message"));
              return;
            }
            let orderItem = this.itemToOrderItem(item);
            this.addOrderItem(orderItem);
            if (this.sideOrder) {
              setTimeout(() => {
                this.navBack();
              }, 0);
            }
          } else this.navOrderView(item);
        }
      }

      /*
      if (item.redeemItem && this.$store.state.member == null) {
        this.$root.memberLoginDialog().then(logined => {
          if (logined) {
            this.navOrderView(item);
          }
        });
      } else if (this.getNewBundleItem != null) {
        this.getNewBundleItem(item).then(() => {
          this.navBack();
        });
      } else {
        this.navOrderView(item);
      }
      */
    },

    navOrderView(item) {
      let params = { item: item, sideOrder: this.sideOrder };
      if (item.bItems != null && item.bItems.length > 0 && this.$store.state.serverBuildNo >= 143) {
        this.navName("OrderBundle", params);
      } else {
        this.navName("Order", params);
      }
    },

    checkOutClicked() {
      if (this.$store.state.order.orderItems.length == 0) return;

      this.rest_canAcceptOrder(this.$store.state.order.orderType).then(resp => {
        this.$store.state.storeOrderHours = resp;

        if (this.$store.getters.acceptOrder) {
          if (this.$store.state.order.login == null) {
            if (
              this.$store.state.memberEnabled &&
              this.$store.state.memberOptional &&
              this.$store.state.member == null //&&
              //this.$store.state.order.redeemedPointsTotal == 0
            ) {
              this.showLoginSelector = true;
            } else {
              //this.$store.state.loginAsGuest = !this.$store.state.memberEnabled;
              this.$refs.loginSelector.login(this.$store.state.memberEnabled);
            }
          } else {
            this.loginCompleted();
          }
        } else {
          this.$root.messageDialog(this.$t("not_acception_order"), "", this.$t("not_acception_order_message"));

          return;
        }
      });
    },

    loginCancel() {
      this.showLoginSelector = false;
    },

    loginCompleted() {
      this.showLoginSelector = false;
      this.calculateTotal();
      this.navName("Checkout");
    },

    searchItem() {
      let orderType = this.$store.state.order.orderType;
      if (this.$store.state.orderMenu == 1) {
        let seachText = this.searchText;
        if (seachText == "" || seachText == null) {
          this.searchRedeemResult = [];
        } else {
          seachText = seachText.toLowerCase();
          this.searchRedeemResult = this.$store.state.redeemItems.filter(
            item =>
              !item.bItem &&
              item.catMenuTypes.includes(orderType) &&
              (item.descr.toLowerCase().includes(seachText) ||
                item.descr1.toLowerCase().includes(seachText) ||
                item.descr2.toLowerCase().includes(seachText))
          );
        }

        this.searchRedeemText = this.searchText;
      } else {
        let seachText = this.searchText;
        if (seachText == "" || seachText == null) {
          this.searchMenuResult = [];
        } else {
          seachText = seachText.toLowerCase();
          this.searchMenuResult = this.$store.state.items.filter(
            item =>
              !item.bItem &&
              item.catMenuTypes.includes(orderType) &&
              (item.descr.toLowerCase().includes(seachText) ||
                item.descr1.toLowerCase().includes(seachText) ||
                item.descr2.toLowerCase().includes(seachText))
          );
        }

        this.searchMenuText = this.searchText;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/variables.scss";
/*
.store-cover {
  max-height: 300px;
  height: auto;
  width: 100%;
  object-fit: cover;

  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-left: -12px !important;
}
*/
/*
.store-logo {
  height: 150px;
  object-fit: contain;

  margin: 5px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
*/

.store-message {
  padding: 10px 10px;
  background-color: var(--v-secondary-lighten1);
  color: var(--v-secondaryText-base);
  text-align: center;

  .col {
    padding: 0px;
  }
}

.search-box {
  position: sticky;
  top: calc(#{$header-height});
  background-color: white;
  margin-right: -12px !important;
  margin-left: -12px !important;
  padding-right: 12px !important;
  padding-left: 12px !important;
  z-index: 1;
}

.not-accept-order {
  text-align: center;
  padding: 10px;
}

.v-slide-group__prev {
  min-width: 30px;
}

.v-slide-group__next {
  min-width: 30px;
}
</style>
